import { tryAgainLaterText } from './addSharedFolderUserOrchestrator.locstring.json';
import { cantCompleteRequestText } from 'owa-locstrings/lib/strings/cantcompleterequesttext.locstring.json';
import loc from 'owa-localize';
import { orchestrator } from 'satcheljs';
import { addSharedFolderUser } from '../actions/publicActions';
import Folder from '../store/schema/Folder';
import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';
import { setMailboxData, addSharedFolderUserEmail } from '../actions/internalActions';
import { SHARED_FOLDERS_TREE_TYPE } from '../util/folderConstants';
import addSharedFoldersService from '../services/addSharedFoldersService';
import { confirm } from 'owa-confirm-dialog';

import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';

/**
 * Orchestrator that adds the shared folder user to store
 */
export default orchestrator(addSharedFolderUser, async actionMessage => {
    const { displayName, principalSMTPAddress, skipServerValidation = false } = actionMessage;
    try {
        // While initializing the shared folder root, we add it directly in folder pane if we get the user info in the getOtherMailboxConfiguration response
        // User can explicitly remove the shared folder user, if he gets an error while expanding the tree
        if (!skipServerValidation) {
            const response = await addSharedFoldersService(displayName, principalSMTPAddress);
            if (!response) {
                return;
            }
        }
    } catch (error) {
        confirm(loc(cantCompleteRequestText), loc(tryAgainLaterText), false, {
            hideCancelButton: true,
        });
        trace.error('Add shared folder API returned error ' + error);
        return;
    }
    const folder: Folder = {
        FolderId: {
            Id: principalSMTPAddress,
        },
        isHidden: false,
        DisplayName: displayName,
        treeType: SHARED_FOLDERS_TREE_TYPE,
        principalSMTPAddress: principalSMTPAddress,
    };

    setMailboxData(principalSMTPAddress, folder, MailboxLoadStateEnum.Uninitialized);
    addSharedFolderUserEmail(principalSMTPAddress);
    // Will only log add shared folder request initiated by the user.
    if (!skipServerValidation) {
        logUsage('Triage_SharedFolders_AddFolder');
    }
});
